
export const getLuaEditorData = (state) => {
    return state.constructs.handlers;
}